import React from "react";
// import { Star } from "lucide-react";
import HeroImage from "../../assets/hero-img-slider-2.jpg";
// import { Stars } from "lucide-react";

const AboutHero = () => {
  return (
    <div className="AboutHero">
      <section className="relative overflow-hidden bg-white text-black">
        {/* Abstract tech background elements */}
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 md:py-20 flex flex-col md:flex-row items-center">
          <div className="md:w-1/2 mb-12 md:mb-0 md:pr-12">
            <div className="inline-block bg-transparent text-blue-600 border border-blue-600
             backdrop-blur-sm px-4 py-1 rounded-full text-sm font-medium mb-6">
              About <span className="font-bold">NYM</span>
            </div>
            <h1 className="text-3xl md:text-4xl font-bold mb-6 leading-tight">
              We Are Shaping The <span className="text-blue-600">Future</span> Of Technology
            </h1>
            <p className="text-md text-gray-700 mb-8 max-w-lg">
              NYM Technologies Limited  Founded in 2018, we've been at the forefront of technological innovation,
              helping businesses transform and thrive in the digital age.
            </p>
            <div className="flex flex-wrap gap-4">
              <button className="bg-blue-600 text-white hover:bg-blue-500 transition px-6 py-3 rounded-lg font-medium">
                Our Services
              </button>
              <button className="border border-blue-500 hover:bg-white/10 transition px-6 py-3 rounded-lg font-medium">
                Contact Us
              </button>
            </div>
          </div>
          <div className="md:w-1/2 relative">
            <div className="relative z-10 bg-black p-2 rounded-2xl shadow-2xl overflow-hidden">
              <img src={HeroImage} alt="Team collaboration"
                className="w-full h-auto rounded-xl relative z-10" />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutHero;
